module.exports = __webpack_public_path__ + "img/icon-cancelled.777b93c6.svg";